<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <v-row class="mb-2">
    <v-col cols="7" class="mx-n4 mt-1">
      <v-card-title>Cacher un item</v-card-title>
    </v-col>

    <v-col cols="10" class="mt-n8">
      <v-autocomplete
        v-model="actionValue.item"
        :search-input.sync="queryProductSearch"
        :hide-no-data="loading || items.length === 0"
        :loading="loading"
        :item-text="getFieldText"
        item-value="objectID"
        item-color="info"
        menu-props="light"
        label="Sélectionner un item"
        chips
        :items="items"
        no-filter
        color="blue"
        clearable
        :rules="[v => !!v || 'Required'] "
        return-object
      >
        <template #item="{ item }">
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.package }} / {{ item.uuid }} / {{ item.objectID }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script setup>

import { ref, computed, watch } from 'vue';
import { useStore } from 'vue2-helpers/vuex';

import { useApolloClient } from '@vue/apollo-composable';

import { getGraphqlSchema } from '@/graphql/index';

const props = defineProps({ action: { type: Object, required: true } });

const actionValue = ref(props.action);
const store = useStore();
const { resolveClient } = useApolloClient();

const queryProductSearch = ref(null);
const products = ref([]);
const loading = ref(false);

const items = computed(() => {
  if (actionValue.value.item) {
    return products.value.concat([{
      objectID: actionValue.value.item.objectID,
      name: actionValue.value.item.name,
      uuid: actionValue.value.item.uuid
    }]);
  }
  return products.value;
});

const getFieldText = item => `${item.name} | ${item.uuid}`;

let observable = null;

const searchAlgolia = search => {
  loading.value = true;
  products.value = [];

  const contextFilters = store.getters.contexAndAgencyFilters;

  if (observable) {
    observable.unsubscribe();
  }

  const apollo = resolveClient();
  const watchedQuery = apollo.watchQuery({
    query: getGraphqlSchema('searchAlgolia'),
    variables: {
      query: search || '',
      args: {
        enableRules: false,
        filters: contextFilters || '',
        attributesToRetrieve: [
          'name',
          'uuid',
          'context',
          'package'
        ]
      }
    }
  });

  // Subscribe to it, and do something with the data
  observable = watchedQuery.subscribe(({ data }) => {
    products.value = data.searchAlgolia.items.map(i => ({
      uuid: i.uuid,
      name: i.name,
      package: i.package,
      objectID: i.objectID,
      context: i.context
    }));
    loading.value = false;
  });
};

watch(() => queryProductSearch.value, val => {
  searchAlgolia(val);
});

</script>

<style>
</style>
